import React from "react";


import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import FilterNoneOutlinedIcon from '@material-ui/icons/FilterNoneOutlined';

import { ZONIC_MODELS } from '../../../Models';

import styles from "./ModelSelection.module.css";

export default function ModelSelection(props:{onSelect: (id:any) => void; initialElement: any}) {
  const {onSelect, initialElement} = props;

  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState(initialElement);

  const toggleDrawer = (open: boolean) => (
      event: React.KeyboardEvent | React.MouseEvent,
    ) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setOpen(open);
    };
  
  const selectElement = (element: any) => {
    setOpen(false);
    setSelected(element);
    onSelect(element);
  }


  return (
    <div>
      <span style={{color: "var(--zonic-color)"}}>
      <div className={'instruction-info-field'}>
          <div className={'instruction-info-back'} style={{
            width: 160,
            height: 60,
            borderRadius: 4,
            left: -20,
            top: -11,
            }}>
            <p style={{top:-55, left:10}}>Modellauswahl</p>
          </div>
          <Button style={{width:'120px', backgroundColor: '#FFF'}} onClick={toggleDrawer(true)}  size="large" color="inherit" variant="outlined">
              <FilterNoneOutlinedIcon />
          </Button>
        </div>
      </span>
      <Drawer
      anchor={'bottom'}
      open={open}
      onClose={toggleDrawer( false)}
      >
          <div className={styles.Container}>
              {/* <div className={styles.Back}>
                <Button style={{borderRadius:'50%', width:64, height:64}}  size="large" color="inherit" onClick={() => {setOpen(false);} } variant="outlined">
                    <CloseIcon />
                </Button>
              </div> */}
              <div style={{display:'flex', justifyContent: 'center', height: '200px', backgroundColor: '#000'}}>
                  <img style={{maxHeight: '200px'}} alt="" src="/assets/images/ZONIC_Logo.png" />
              </div>
              {ZONIC_MODELS.map((group) => (
                <div className={styles.Group} key={`${group.groupname}-container`}>
                  <h3 className={styles.ItemHeadline} key={`${group.groupname}-headline`}>{group.groupname}</h3>
                  <Grid key={group.groupname} container justify="center" spacing={4}>
                    {group.models.map((value) => (
                      <Grid key={value.name} item>
                        <Paper 
                          className={`${styles.Item} ${value.id === selected.id ? styles.ItemSelected : ''}`} onClick={() => {
                          selectElement(value);
                        }}>
                          <div 
                            style={{
                              backgroundImage: 'url("/assets/images/HG-ZONIC-Chrom.jpg")',
                            }}
                            className={styles.ItemContent}>
                            {value.name}
                          </div>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              ))}
          </div>
      </Drawer>
    </div>
  );
}